import { generateUrl, getReturnToUrl, paths } from 'shared/base';

const onlyAnonymousPaths = new Set([paths.platform.auth.login]);

export function authGuardIsAllowed({
  isAuthenticated,
  isInitialized,
  manuallySignedOut,
  pathname,
  registered,
  returnTo,
  searchParams,
}: {
  isAuthenticated: boolean;
  isInitialized: boolean;
  manuallySignedOut: boolean;
  pathname: string;
  registered: boolean;
  returnTo: string | undefined;
  searchParams: URLSearchParams;
}): string | boolean {
  if (!isInitialized) {
    return false;
  }

  let desiredPath = onlyAnonymousPaths.has(pathname)
    ? undefined
    : returnTo || searchParams.size > 0
      ? `${pathname}?${searchParams.toString()}`
      : pathname;
  desiredPath = ['/', ''].includes(desiredPath || '') ? undefined : desiredPath;

  if (!isAuthenticated && !onlyAnonymousPaths.has(pathname)) {
    return generateUrl({
      pathname: paths.platform.auth.login,
      query: {
        returnTo: manuallySignedOut ? undefined : desiredPath,
      },
    });
  } else if (isAuthenticated && !registered && pathname !== paths.onboarding) {
    return generateUrl({
      pathname: paths.onboarding,
      query: {
        returnTo: desiredPath,
      },
    });
  } else if (
    isAuthenticated &&
    registered &&
    [...onlyAnonymousPaths, paths.onboarding].includes(pathname)
  ) {
    return getReturnToUrl(returnTo) || paths.platform.index;
  }

  return true;
}
